import React, { useState } from "react";
import styles from "./FilterButtonDrawer.module.scss";
import { motion, AnimatePresence } from "framer-motion";

export interface FilterButtonDrawerProps {
  label: string;
  childrenRender?: (param: { closeDrawer: () => void }) => JSX.Element;
  filterStatusRender?: (param: { closeDrawer: () => void }) => JSX.Element;
  isActived?: boolean;
}

const FilterIcon = ({
  size = 30,
  color = "black",
}: {
  size: number;
  color: string;
}) => (
  <svg
    width={size}
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1C18 1.26522 17.8946 1.51957 17.7071 1.70711C17.5196 1.89464 17.2652 2 17 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1ZM2 5.5C2 5.23478 2.10536 4.98043 2.29289 4.79289C2.48043 4.60536 2.73478 4.5 3 4.5H15C15.2652 4.5 15.5196 4.60536 15.7071 4.79289C15.8946 4.98043 16 5.23478 16 5.5C16 5.76522 15.8946 6.01957 15.7071 6.20711C15.5196 6.39464 15.2652 6.5 15 6.5H3C2.73478 6.5 2.48043 6.39464 2.29289 6.20711C2.10536 6.01957 2 5.76522 2 5.5ZM5 10C5 9.73478 5.10536 9.48043 5.29289 9.29289C5.48043 9.10536 5.73478 9 6 9H12C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11H6C5.73478 11 5.48043 10.8946 5.29289 10.7071C5.10536 10.5196 5 10.2652 5 10Z"
      fill={color}
    />
  </svg>
);

const CrossIcon = ({
  size = 30,
  color = "black",
}: {
  size: number;
  color: string;
}) => (
  <svg
    width={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17L1 1M17 1L1 17"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);
export function FilterButtonDrawer({
  label = "Filtre",
  childrenRender,
  filterStatusRender,
  isActived,

}: FilterButtonDrawerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const closeDrawer = () => setIsOpen(false);
  const isActivedFlag = isActived !== undefined ? isActived : isOpen;
  return (

      <div className={[styles["filter-container"], styles["filter-container--"+ isActivedFlag ]].join(" ")} >
        <div
          className={[
            styles["filter-container__status-container"],
            styles["status-container"],
          ].join(" ")}
        >
          <FilterButton label={label} onClick={() => setIsOpen(!isOpen)} isActived={isOpen} />
          {filterStatusRender && (
            <div
              className={[
                styles["status-container__status-content"],
                styles["status-content"],
              ].join(" ")}
            >
              {filterStatusRender({ closeDrawer })}
            </div>
          )}
        </div>
        <AnimatePresence mode="wait">
        {childrenRender && isOpen && (
          <div 
            className={[styles["filter-container"]].join(" ")}

            >
            {childrenRender({ closeDrawer })}
          </div>
        )}
            </AnimatePresence>
      </div>

  );
}

export interface FilterButtonProps {
  label: string;
  onClick: () => void;
  isActived?: boolean;
}
export function FilterButton({ label = "Filtre", onClick, isActived }: FilterButtonProps) {
  const isActivedFlag = isActived? "active" : "";
  return (
    <button className={[styles["filter-button"], styles["filter-button--"+isActivedFlag]].join(" ")} onClick={onClick}>
      <div className={[styles["filter-button__icon"]].join(" ")}>
        {!isActived ?
        <FilterIcon size={15} color="#686868" /> :
        <CrossIcon size={9} color="#686868" />
}
      </div>
      <span className={[styles["filter-button__label"]].join(" ")}>
        {label}
      </span>
    </button>
  );
}

export const FilterStatusItem = ({
  label,
  onClickDelete,
  labelRender
}: {
  label?: string;
  onClickDelete?: () => void;
  labelRender?: () => JSX.Element;
}) => {
  return (
    <button
      className={[styles["filter-status-item"]].join(" ")}
      onClick={onClickDelete}
    >
      <span className={[styles["filter-status-item__label"]].join(" ")}>
        {label}
        {labelRender && labelRender()}
      </span>
      <div
        className={[
          styles["filter-status-item__close-btn"],
          styles["close-btn"],
        ].join(" ")}
      >
        <CrossIcon size={8} color="#ffffffbd" />
      </div>
    </button>
  );
};


export const FilterDrawerContainer = ({children}: {children: React.ReactNode}) => {
  return (

    <motion.div className={[styles["filter-drawer-container"]].join(" ")}
    initial={{opacity: 0,  maxHeight: 0 }}
    animate={{opacity: 1, maxHeight: 300 }}
    exit={{opacity: 0, maxHeight: 0 }}
    transition={{ duration: 0.5, type: "easeInOut" }}>
        <div className={[styles["filter-drawer-container__header"]].join(" ")}>
         

      </div>
      <div className={[styles["filter-drawer-container__content"]].join(" ")}>
      {children}
      </div>
    </motion.div>

  );
}
export default FilterButtonDrawer;
